const FINDEP_HOME_URL = '/simulador'
const FINDEP_LOGIN_URL = '/'

module.exports = { FINDEP_HOME_URL, FINDEP_LOGIN_URL }